import React from "react";
import "../../../assets/css/container/main/AboutFactWeb.css";

export default function PrivacyPolicy() {
	return (
		<div className="about-container">
			<h1 className="about-title">개인정보처리방침</h1>

			<section className="about-section">
				<h2>개인정보 수집 원칙</h2>
				<p>
					FactWeb은 서비스 제공에 반드시 필요한 최소한의 개인정보만을 수집합니다.
					불필요한 정보는 요청하지 않으며,
					이용자의 프라이버시를 최우선으로 보호합니다.
				</p>
			</section>

			<section className="about-section">
				<h2>수집 항목</h2>
				<p>
					소셜 로그인 식별자, 닉네임 등 서비스 운영에 필요한 정보가 수집되며,
					접속 로그 및 IP 정보는 보안 및 부정 이용 방지를 위해 자동 수집될 수 있습니다.
				</p>
			</section>

			<section className="about-section">
				<h2>보관 및 파기</h2>
				<p>
					개인정보는 회원 탈퇴 시 즉시 파기되며,
					관계 법령에 따라 보관이 필요한 경우에만
					해당 기간 동안 안전하게 보관됩니다.
				</p>
			</section>

			<section className="about-section">
				<h2>이용자의 권리</h2>
				<p>
					이용자는 언제든지 자신의 개인정보에 대해
					열람, 수정, 삭제를 요청할 수 있으며,
					FactWeb은 이를 신속히 처리합니다.
				</p>
			</section>
		</div>
	);
}
